import request from '@/axios'

export function  getEventApi (payload, customer_id) {
  return request({
    url: `/schedule/get/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function  CreateGeneralEventApi (payload, customer_id) {
  return request({
    url: `/schedule/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function  UpdateGeneralEventApi (payload, customer_id) {
  return request({
    url: `/schedule/edit/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function  DeleteScheduleApi (customer_id, event_id) {
  return request({
    url: `/schedule/delete/${customer_id}/${event_id}`,
    method: 'POST'
  })
}

//teacher List Api
export function TeacherListApi (customer_id, payload = []) {
  return request({
    url: `/schedule/teachers/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

// Classes teacher List Api
export function ClassesTeacherListApi (customer_id, payload = []) {
  return request({
    url: `/classes/schedules/teachers/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

// Classes teacher List Api
export function ClassesStudentListApi (customer_id, payload = []) {
  return request({
    url: `/classes/schedules/students/${customer_id}`,
    method: 'POST',
    data:payload
  })
}


//room list
export function roomListApi (payload) {
  return request({
    url: '/schedule/room/list',
    method: 'POST',
    data:payload
  })
}


// Class list
export function classListApi (payload) {
  return request({
    url: '/classes/schedules/get-class-schedule',
    method: 'POST',
    data:payload
  })
}

export function StudentListAPi (customer_id, payload = []) {
  return request({
    url: `/schedule/students/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function fetchHolidays (user_id, customer_id, payload) {
  return request({
    url: `/operationalUser/fetchHolidays/${user_id}/${customer_id}`,
    method: 'POST',
    data:payload
  })
}
export function createHolidayApi (user_id, customer_id, payload) {
  return request({
    url: `operationalUser/edit/holiday/${user_id}/${customer_id}`,
    method: 'POST',
    data:payload
  })
}
export function deleteHolidayApi (customer_id, payload) {
  return request({
    url: `operationalUser/delete/holiday/${customer_id}`,
    method: 'POST',
    data:payload
  })
}


export function updateRescheduleApi (course_id, customer_id, payload) {

  return request({
    url:`course/reschedule/${course_id}/${customer_id}`,
    method:'POST',
    data:payload
  })

}

export function cancelRescheduleUpdateApi (customer_id, payload) {

  return request({
    url:`course/reschedule/canceled/${customer_id} `,
    method:'POST',
    data:payload
  })

}


export function getShedulerLogApi (customer_id, payload) {
  return request({
    url:`course/schedule/log/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function cancelSchedulerApi (customer_id, payload) {
  return request({
    url:`course/schedule/cancel/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getCancelSchedulerApi (payload, customer_id) {
  return request({
    url:`course/schedule/get/cancel/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getRoomSchedulerApi (payload, customer_id) {
  return request({
    url:`/schedule/room/get/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getTeacherAvailabilityApi (customer_id, payload) {

  return request({
    url:`course/reschedule/availability/${customer_id}`,
    method:'POST',
    data:payload

  })
}

export function checkCourseOrClass (payload) {
  return request({
    url: '/schedules/course-or-class',
    method: 'POST',
    data: payload
  })
}

export function getAvailableDay (payload) {
  return request({
    url:'course/reschedule/get_available_days',
    method:'POST',
    data:payload
  })
}
// export function  addEvent (payload, customer_id) {
//   return request({
//     url: `/blog/create/${customer_id}`,
//     method: 'POST',
//     data: payload
//   })
// }

// export function  deleteEvent (payload, customer_id) {
//   return request({
//     url: `/blog/create/${customer_id}`,
//     method: 'POST',
//     data: payload
//   })
// }


export function getClassShortList (customer_id) {
  return request({
    url: `/classes/schedules/${customer_id}/get-class-short-list`,
    method: 'GET'
  })
}


export function  getScheduleEventApi (payload, customer_id) {
  return request({
    url: `V1/schedule/get/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  getStudentListForSchedule (payload, customer_id) {
  return request({
    url: `V1/schedule/attendance/list/student/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  getTeacherListForSchedule (payload, customer_id) {
  return request({
    url: `V1/schedule/attendance/list/teacher/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  courseMoreDetails (payload, customer_id) {
  return request({
    url: `V1/schedule/course/more_info/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  courseListForprofile (payload, customer_id, page) {
  return request({
    url: `V1/course/list/students/${customer_id}?page=${page}`,
    method: 'POST',
    data: payload
  })
}

export function schoolHolidays (customer_id) {
  return request({
    url: `users/get_school_holiday/${customer_id}`,
    method: 'GET'
  })
}

export function saveSchoolHolidayApi (customer_id, payload) {
  return request({
    url: `users/set_school_holiday/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function deleteSchoolHolidayApi (customer_id, payload) {
  return request({
    url: `users/delete_school_holiday/${customer_id}`,
    method: 'DELETE',
    data:payload
  })
}

export function  classDetailsFetch (class_id, customer_id) {
  return request({
    url: `classes/show/${class_id}/${customer_id}`,
    method: 'GET'
  })
}

export function  classSubjectFetch (customer_id, payload) {
  return request({
    url: `classes/getPeriodSubject/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  changeUserColor (customer_id, payload) {
  return request({
    url: `operationalUser/update/profile/colour/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
